/**
 * Checks if the agent-interface is loaded on a mobile platform and if the
 * agent-interface is loaded as a Progressive Web App (PWA).
 */

export function isMobilePWA(): boolean {
  return /(Mobile)|(Android)/gi.test(navigator.userAgent) && isPWA();
}

/** Checks if the agent-interface is loaded as a Progressive Web App (PWA). */
export function isPWA(): boolean {
  return window.matchMedia('(display-mode: standalone)').matches;
}
